import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

export default function HeaderBar({ cameraData, onCaptureSnapshot, isCapturing }) {
    const navigate = useNavigate();
    
    const handleBack = () => {
        navigate(-1);
    };

    return (
        <div className="camera-header">
            <button className="camera-back-btn" onClick={handleBack}>
                <i className="ri-arrow-left-line"></i>
                <span>Back</span>
            </button>
            
            <div className="camera-header-main">
                <div className="camera-title-row">
                    <h2 className="camera-title">
                        <i className="ri-camera-line"></i>
                        {cameraData?.name || "Camera Feed"}
                    </h2>
                </div>
                <p className="camera-description">
                    {cameraData?.description || "Plant monitoring and analysis"}
                </p>
            </div>
            
            <div className="camera-controls">
                <button 
                    className="camera-capture-btn" 
                    onClick={onCaptureSnapshot}
                    disabled={isCapturing}
                    title="Capture new snapshot"
                >
                    <i className="ri-camera-line"></i>
                    <span>{isCapturing ? "Capturing..." : "Capture"}</span>
                </button>
            </div>
        </div>
    );
}

HeaderBar.propTypes = {
    cameraData: PropTypes.shape({
        name: PropTypes.string,
        description: PropTypes.string
    }),
    onCaptureSnapshot: PropTypes.func.isRequired,
    isCapturing: PropTypes.bool
}; 